module.exports = __webpack_public_path__ + "img/logo-header.9938568.png";